<div class="_flex _flex-wrap _gap-3" *ngIf="guestCounts && guestCounts.length > 0">
    <div *ngFor="let guestCount of guestCounts" class="_flex _items-center _gap-2" [ngClass]="{'_hidden': guestCount.count === 0}">
        <i class="fa-light _text-primary-1" [ngClass]="getIconForGuestType(guestCount.key)"></i>
        <span class="_text-sm">{{ guestCount.count }} {{ getDisplayName(guestCount.key, guestCount.count) }}</span>
    </div>
</div>